export default __webpack_public_path__ + "static/media/flips_2026_packaged_3.4cf32171.png";